import { Slider, Stack, Typography } from '@mui/material';
import { type FieldPathByValue, useController, useFormContext } from 'react-hook-form';
import { type LandingPageFormValues } from 'src/pages/Settings/memberships/components/landing-page-tab/types';

const STEP = 2;

interface PixelSliderFieldProps {
  name: FieldPathByValue<LandingPageFormValues, number>;
  label: string;
  min: number;
  max: number;
  readOnly: boolean;
  /** Shown in place of the value at `min`, for a slider whose lowest stop means "none". */
  minLabel?: string;
}

export const PixelSliderField = ({
  name,
  label,
  min,
  max,
  readOnly,
  minLabel,
}: PixelSliderFieldProps) => {
  const { control } = useFormContext<LandingPageFormValues>();
  const { field } = useController({ name, control });

  return (
    <Stack direction="row" alignItems="center" gap={2} py={1}>
      <Typography variant="body2" fontWeight={500} flexShrink={0}>
        {label}
      </Typography>
      <Slider
        value={field.value}
        onChange={(_, next) => field.onChange(next)}
        onBlur={field.onBlur}
        min={min}
        max={max}
        step={STEP}
        disabled={readOnly}
        size="small"
        aria-label={label}
      />
      <Typography variant="body2" color="text.secondary" minWidth="5ch" flexShrink={0}>
        {field.value === min && minLabel ? minLabel : `${field.value}px`}
      </Typography>
    </Stack>
  );
};
